// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { cartTitleStyles } from "@pace/App/Widgets/Cart/CartTitle";
import { color } from "@pace/XDL/Utilities";
import { css } from "styled-components";

cartTitleStyles.container = {
    css: css`
        display: flex;
        align-items: baseline;
    `,
};
cartTitleStyles.pageTitle = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
        margin-right: 32px;
        /* Override OOTB h1 print style */
        @media print {
            font-size: 32px !important;
        }
    `,
};
cartTitleStyles.itemCountText = {
    variant: "h5",
    forwardAs: "h2",
    css: css`
        margin-bottom: 0;
        margin-right: 10px;
    `,
};
cartTitleStyles.productCountText = {
    variant: "h5",
    forwardAs: "h2",
    css: css`
        margin-bottom: 0;
        padding-left: 10px;
        position: relative;
        &:before {
            content: "";
            height: 80%;
            width: 1px;
            position: absolute;
            left: 0;
            top: 0;
            margin: 2px 0;
            background-color: ${color("common.border")};
        }
    `,
};
